export const PASSWORD_LENGTH = 16;

export const PASSWORD_CHARACTER_CLASSES = Object.freeze({
    lowercase: 'abcdefghijklmnopqrstuvwxyz',
    uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    digits: '0123456789',
    symbols: '!@#$%^&*()-_=+[]{}:,.?',
});

const allCharacters = Object.values(PASSWORD_CHARACTER_CLASSES).join('');

const randomIndex = (max) => {
    if (!window.crypto?.getRandomValues) {
        throw new Error('Secure random number generation is not available');
    }

    const maxUint32 = 0x100000000;
    const limit = maxUint32 - (maxUint32 % max);
    const values = new Uint32Array(1);
    do {
        window.crypto.getRandomValues(values);
    } while (values[0] >= limit);
    return values[0] % max;
};

const randomCharacter = (characters) => characters[randomIndex(characters.length)];

export const generatePassword = (length = PASSWORD_LENGTH) => {
    if (length !== PASSWORD_LENGTH) {
        throw new RangeError(`Password length must be ${PASSWORD_LENGTH}`);
    }

    const password = Object.values(PASSWORD_CHARACTER_CLASSES).map(randomCharacter);
    while (password.length < length) {
        password.push(randomCharacter(allCharacters));
    }

    for (let index = password.length - 1; index > 0; index -= 1) {
        const swapIndex = randomIndex(index + 1);
        [password[index], password[swapIndex]] = [password[swapIndex], password[index]];
    }

    return password.join('');
};

export const hasPasswordRequirements = (password) => {
    if (typeof password !== 'string' || password.length !== PASSWORD_LENGTH) return false;
    return Object.values(PASSWORD_CHARACTER_CLASSES).every((characters) =>
        [...password].some((character) => characters.includes(character))
    );
};